import { useMutation } from '@tanstack/react-query';
import { createRelationships } from 'shared/services/backend-api';
import { MinimalRelationship } from 'shared/types/relationship';

export const useCreateRelationshipsMutation = () =>
  useMutation({
    mutationFn: (relationships: MinimalRelationship[]) =>
      createRelationships(relationships),
  });
